import { Factory, trait } from 'miragejs';

export default Factory.extend({
  // statuses: in_progress, done, failed, and scheduled
  // https://github.com/envoy/envoy-web/pull/4242/files#diff-698d73d2682a7f3d649dd3bdc3e8da0aR9
  status: 'done',
  message: 'blah blah blah',
  info: () => {},
  startedAt: () => new Date(),
  endedAt: () => new Date(),
  providerName: 'mirage',

  withLocation: trait({
    afterCreate(syncBatch, server) {
      syncBatch.update({
        location: server.schema.locations.first(),
      });
    },
  }),
});
